var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-card',{attrs:{"get-report":_vm.getReport}}),_c('b-card',{attrs:{"no-body":""}},[_c('report-table'),_c('report-income-table'),(_vm.loading)?_c('b-card-body',[_c('pre-loading')],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }